import React from 'react'

import { Link } from 'react-router'
import { DataCard, Details, Title } from '../data-card/data-card-parts'

export default ({
  location,
  linkUrlBase,
  children
}) => (
  <DataCard key={location.id}>
    <Link to={`${linkUrlBase}/${location.id}`}>
      <Details>
        <Title text={location.name} />
        {children}
      </Details>
    </Link>
  </DataCard>
)



// WEBPACK FOOTER //
// ./src/components/locations/location-card.js